import { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

const API = process.env.REACT_APP_API_URL;

function formatTime(iso) {
  return new Date(iso).toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' });
}
function formatDate(iso) {
  return new Date(iso).toLocaleDateString('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric' });
}

export default function Storico() {
  const { utente } = useAuth();
  const [timbrature, setTimbrature] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filtro, setFiltro] = useState('oggi');
  const [utenti, setUtenti] = useState([]);
  const [filtroDipendente, setFiltroDipendente] = useState('');
  const isAdmin = utente?.ruolo === 'admin' || utente?.ruolo === 'responsabile';

  useEffect(() => {
    if (isAdmin) {
      axios.get(`${API}/utenti?perPage=100`)
        .then(res => setUtenti(res.data.items || []))
        .catch(() => {});
    }
  }, []);

  useEffect(() => {
    caricaTimbrature();
  }, [filtro, filtroDipendente]);

  const caricaTimbrature = async () => {
    setLoading(true);
    try {
      let url = `${API}/timbrature?perPage=100`;
      if (filtroDipendente) url += `&dipendente_id=${filtroDipendente}`;
      const res = await axios.get(url);
      let items = res.data.items || [];

      const now = new Date();
      if (filtro === 'oggi') {
        items = items.filter(t => new Date(t.timestamp_server).toDateString() === now.toDateString());
      } else if (filtro === 'settimana') {
        const settimanaFa = new Date(now - 7 * 86400000);
        items = items.filter(t => new Date(t.timestamp_server) >= settimanaFa);
      } else if (filtro === 'mese') {
        const meseFa = new Date(now - 30 * 86400000);
        items = items.filter(t => new Date(t.timestamp_server) >= meseFa);
      }

      setTimbrature(items);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  // Raggruppa per dipendente e calcola ore lavorate
  const calcolaOre = (timbratureDip) => {
    let totaleMinuti = 0;
    const ordinate = [...timbratureDip].sort((a, b) => new Date(a.timestamp_server) - new Date(b.timestamp_server));
    for (let i = 0; i < ordinate.length - 1; i++) {
      if ((ordinate[i].Tipo || ordinate[i].tipo) === 'ingresso' && (ordinate[i + 1].Tipo || ordinate[i + 1].tipo) === 'uscita') {
        const diff = new Date(ordinate[i + 1].timestamp_server) - new Date(ordinate[i].timestamp_server);
        totaleMinuti += diff / 60000;
        i++;
      }
    }
    const ore = Math.floor(totaleMinuti / 60);
    const minuti = Math.round(totaleMinuti % 60);
    return `${ore}h ${minuti}m`;
  };

  return (
    <div style={{ padding: '24px 16px', paddingBottom: 90 }}>
      <h2 style={{ color: '#f1f5f9', fontSize: 22, fontWeight: 800, marginBottom: 6 }}>Storico Presenze</h2>
      <p style={{ color: '#64748b', fontSize: 14, marginBottom: 20 }}>{timbrature.length} timbrature</p>

      {/* Filtri periodo */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
        {[['oggi', 'Oggi'], ['settimana', '7 giorni'], ['mese', '30 giorni'], ['tutti', 'Tutti']].map(([v, l]) => (
          <button key={v} onClick={() => setFiltro(v)}
            style={{ flex: 1, padding: '9px 4px', borderRadius: 10, border: `1px solid ${filtro === v ? '#f59e0b' : '#334155'}`, background: filtro === v ? '#f59e0b18' : 'transparent', color: filtro === v ? '#f59e0b' : '#64748b', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>
            {l}
          </button>
        ))}
      </div>

      {/* Filtro dipendente (solo admin) */}
      {isAdmin && (
        <select value={filtroDipendente} onChange={e => setFiltroDipendente(e.target.value)}
          style={{ width: '100%', padding: '11px 12px', background: '#1e293b', border: '1px solid #334155', borderRadius: 10, color: '#f1f5f9', fontSize: 14, marginBottom: 16, boxSizing: 'border-box', outline: 'none' }}>
          <option value="">Tutti i dipendenti</option>
          {utenti.map(u => (
            <option key={u.id} value={u.id}>{u.Nome} {u.Cognome}</option>
          ))}
        </select>
      )}

      {/* Riepilogo ore */}
      {timbrature.length > 0 && (
        <div style={{ background: '#1e293b', borderRadius: 14, padding: 16, marginBottom: 16, border: '1px solid #334155', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <p style={{ color: '#64748b', fontSize: 11, fontWeight: 700, letterSpacing: '0.08em', margin: '0 0 4px' }}>ORE LAVORATE</p>
            <p style={{ color: '#f59e0b', fontSize: 24, fontWeight: 800, margin: 0 }}>{calcolaOre(timbrature)}</p>
          </div>
          <div style={{ textAlign: 'right' }}>
            <p style={{ color: '#64748b', fontSize: 11, fontWeight: 700, letterSpacing: '0.08em', margin: '0 0 4px' }}>TIMBRATURE</p>
            <p style={{ color: '#f1f5f9', fontSize: 24, fontWeight: 800, margin: 0 }}>{timbrature.length}</p>
          </div>
        </div>
      )}

      {loading ? (
        <p style={{ color: '#475569', textAlign: 'center', padding: 30 }}>Caricamento...</p>
      ) : timbrature.length === 0 ? (
        <p style={{ color: '#475569', textAlign: 'center', padding: 30 }}>Nessuna timbratura nel periodo</p>
      ) : timbrature.map(t => {
        const tipo = t.Tipo || t.tipo;
        const nomeDip = t.expand?.Dipendente
          ? `${t.expand.Dipendente.Nome || ''} ${t.expand.Dipendente.Cognome || ''}`.trim()
          : null;
        const nomeReparto = t.expand?.Reparto?.Nome || '';
        const nomeSede = t.expand?.Sede?.Nome || '';

        return (
          <div key={t.id} style={{ background: '#1e293b', borderRadius: 12, padding: '12px 14px', marginBottom: 8, border: '1px solid #334155', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <div style={{ width: 36, height: 36, borderRadius: 8, background: tipo === 'ingresso' ? '#10b98118' : '#ef444418', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16, border: `1px solid ${tipo === 'ingresso' ? '#10b98144' : '#ef444444'}`, flexShrink: 0 }}>
                <span style={{ color: tipo === 'ingresso' ? '#10b981' : '#ef4444' }}>{tipo === 'ingresso' ? '→' : '←'}</span>
              </div>
              <div>
                <p style={{ color: '#f1f5f9', fontSize: 14, fontWeight: 600, margin: 0, textTransform: 'capitalize' }}>{tipo}</p>
                {isAdmin && nomeDip && (
                  <p style={{ color: '#f59e0b', fontSize: 12, fontWeight: 600, margin: '2px 0 0' }}>{nomeDip}</p>
                )}
                {(nomeReparto || nomeSede) && (
                  <p style={{ color: '#475569', fontSize: 11, margin: '2px 0 0' }}>
                    {nomeReparto}{nomeReparto && nomeSede ? ' · ' : ''}{nomeSede}
                  </p>
                )}
              </div>
            </div>
            <div style={{ textAlign: 'right', flexShrink: 0 }}>
              <p style={{ color: '#f1f5f9', fontSize: 14, fontWeight: 700, margin: 0 }}>{formatTime(t.timestamp_server)}</p>
              <p style={{ color: '#475569', fontSize: 11, margin: 0 }}>{formatDate(t.timestamp_server)}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
}
